export default __webpack_public_path__ + "static/media/temp.c9ad2902.svg";